module.exports = __webpack_public_path__ + "static/media/profile.11a59fc0.svg";